var map = {
	"./Project/resources/components/canvas/blocks/modules/products/admin/BlockPanel.vue": 50025,
	"./Project/resources/components/canvas/blocks/modules/products/admin/LoopItemPanel.vue": 53255,
	"./Project/resources/components/canvas/blocks/modules/products/block.js": 79858,
	"./Project/resources/components/canvas/blocks/modules/projectSlider/admin/BlockPanel.vue": 42631,
	"./Project/resources/components/canvas/blocks/modules/projectSlider/admin/LoopItemPanel.vue": 23842,
	"./Project/resources/components/canvas/blocks/modules/projectSlider/block.js": 99693,
	"./Project/resources/components/website/modules/projects/index.js": 92794
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9545;